import React from "react";
import { hydrate } from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ReactGa from "react-ga";

import { configureStore } from "../shared/store";
import App from "../shared/App";
import IntlProvider from "../shared/i18n/IntlProvider";
import createHistory from "../shared/store/history";

ReactGa.initialize("UA-171107564-1");

const history = createHistory();

history.listen(function(location: Location) {
    ReactGa.set({ page: location.pathname });
    ReactGa.pageview(location.pathname + location.search);
});

// Create/use the store
// history MUST be passed here if you want syncing between server on initial route
const store =
    window.store ||
    configureStore({
        initialState: window.__PRELOADED_STATE__,
    });

hydrate(
    <Provider store={ store }>
        <Router history={ history }>
            <IntlProvider>
                <HelmetProvider>
                    <App />
                </HelmetProvider>
            </IntlProvider>
        </Router>
    </Provider>,
    document.getElementById("root")
);

if (process.env.NODE_ENV === "development") {
    if (module.hot) {
        module.hot.accept();
    }

    if (!window.store) {
        window.store = store;
    }
}
